import React from 'react';
import { SVGProps } from 'react';

interface IconAttributes extends SVGProps<SVGSVGElement> {
  name: string;
  className?: string;
  color?: string;
  size?: string;
}

declare var global: any;

const Icon = (props: IconAttributes) => {
  const { name, className, color } = props;

  return (
    <svg
      {...props}
      className={`${className ?? ''} icon`}
      style={{ color: color, fill: color, ...props.style }}
    >
      <use href={`${global.SvgIconsPath}#icon-${name}`}></use>
    </svg>
  );
};

export default Icon;
